import React from 'react';
import BaseTextLink from './BaseTextLink';
import './style/SimpleTextLink.css';

export default function SimpleTextLink({ className, ...restProps }) {
  const classes = ['SimpleTextLink', className];
  return <BaseTextLink className={classes.join(' ')} {...restProps} />;
}



// WEBPACK FOOTER //
// ./src/app/ui/core/common/SimpleTextLink.js